<ion-content>
  <ion-grid>
    

    <ion-row class="ion-text-center ion-justify-content-center">
      <ion-col size="auto">
        <ion-card>
          <ion-card-content class="ion-margin">
            <ion-text>
              <h1>Progetto Cruscotto Medici</h1>

              <div class="ion-margin-top">
                <p>Per informazioni o assistenza contattare:</p>
                <p>
                  
                </p>
              </div>
            </ion-text>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-card>
          <ion-card-content>
            <ion-grid>
              <ion-row class="ion-justify-content-around">
                <ion-col size="12" size-md="6" size-lg="3">
                  <ion-img class="credits-logo" src="assets/logo/fbk.svg" alt="Logo Fbk"></ion-img>
                </ion-col>
                
                <ion-col size="12" size-md="6" size-lg="4"> </ion-col>
                <ion-col size="12" size-md="6" size-lg="4">
                  <ion-img
                    class="credits-logo"
                    [src]="srcLogo"
                    alt="Logo Provincia di Ragusa"
                  ></ion-img>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-text-left ion-justify-content-center">
      <ion-col size="12">
        <ion-card>
          <ion-card-content>
            <div class="ion-margin-bottom">
              <p>
                <strong>
                  Parte delle immagini e risorse multimediali utilizzati in questo sito sono da
                  attribuire a:
                </strong>
              </p>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/dinosoftlabs" title="DinosoftLabs"
                >DinosoftLabs</a
              >
              from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is
              licensed by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/vectors-market" title="Vectors Market"
                >Vectors Market</a
              >
              from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is
              licensed by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            
            <div>
              Icons made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/monkik" title="monkik">monkik</a> from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/smashicons" title="Smashicons"
                >Smashicons</a
              >
              from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/roundicons" title="Roundicons"
                >Roundicons</a
              >
              from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/ultimatearm" title="ultimatearm"
                >ultimatearm</a
              >
              from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/dinosoftlabs" title="DinosoftLabs"
                >DinosoftLabs</a
              >
              from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is
              licensed by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/prettycons" title="prettycons"
                >prettycons</a
              >
              from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/becris" title="Becris">Becris</a> from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/popcorns-arts" title="Icon Pond"
                >Icon Pond</a
              >
              from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/becris" title="Becris">Becris</a> from
              <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed
              by
              <a
                href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
              >
                CC 3.0 BY
              </a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/authors/pixel-perfect" title="Pixel perfect"
                >Pixel perfect</a
              >
              from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
            </div>

            
            <div>
              Icons made by
              <a href="https://www.flaticon.com/free-icon/paper_812904" title="Those Icons"
                >Those Icons</a
              >
              from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
            </div>

            
            <div>Icons by <a href="https://www.svgrepo.com/" title="SVGRepo">svgrepo.com</a></div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
